/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { BodyPostV1ExecuteGraphAgent } from "../../models/bodyPostV1ExecuteGraphAgent.ts";

import type { CreateGraph } from "../../models/createGraph.ts";

import type { DeleteGraphResponse } from "../../models/deleteGraphResponse.ts";

import type { GetV1GetGraphVersionParams } from "../../models/getV1GetGraphVersionParams.ts";

import type { GetV1GetSpecificGraphParams } from "../../models/getV1GetSpecificGraphParams.ts";

import type { GetV1ListGraphExecutionsParams } from "../../models/getV1ListGraphExecutionsParams.ts";

import type { GetV1UserCostSummaryParams } from "../../models/getV1UserCostSummaryParams.ts";

import type { Graph } from "../../models/graph.ts";

import type { GraphExecution } from "../../models/graphExecution.ts";

import type { GraphExecutionMeta } from "../../models/graphExecutionMeta.ts";

import type { GraphExecutionWithNodes } from "../../models/graphExecutionWithNodes.ts";

import type { GraphExecutionsPaginated } from "../../models/graphExecutionsPaginated.ts";

import type { GraphMeta } from "../../models/graphMeta.ts";

import type { GraphModel } from "../../models/graphModel.ts";

import type { GraphSettings } from "../../models/graphSettings.ts";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { PostV1ExecuteGraphAgentParams } from "../../models/postV1ExecuteGraphAgentParams.ts";

import type { SetActiveGraphVersionResponse } from "../../models/setActiveGraphVersionResponse.ts";

import type { SetGraphActiveVersion } from "../../models/setGraphActiveVersion.ts";

import type { UpdateGraphResponse } from "../../models/updateGraphResponse.ts";

import type { UserExecutionCostSummary } from "../../models/userExecutionCostSummary.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getV1ListAllExecutionsResponse200 = {
  data: GraphExecutionMeta[];
  status: 200;
};

export type getV1ListAllExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1ListAllExecutionsResponseSuccess =
  getV1ListAllExecutionsResponse200 & {
    headers: Headers;
  };
export type getV1ListAllExecutionsResponseError =
  getV1ListAllExecutionsResponse401 & {
    headers: Headers;
  };

export type getV1ListAllExecutionsResponse =
  | getV1ListAllExecutionsResponseSuccess
  | getV1ListAllExecutionsResponseError;

export const getGetV1ListAllExecutionsUrl = () => {
  return `/api/executions`;
};

/**
 * @summary List all executions
 */
export const getV1ListAllExecutions = async (
  options?: RequestInit,
): Promise<getV1ListAllExecutionsResponse> => {
  return customMutator<getV1ListAllExecutionsResponse>(
    getGetV1ListAllExecutionsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1ListAllExecutionsQueryKey = () => {
  return [`/api/executions`] as const;
};

export const getGetV1ListAllExecutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ListAllExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1ListAllExecutions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1ListAllExecutionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListAllExecutions>>
  > = ({ signal }) => getV1ListAllExecutions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ListAllExecutions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListAllExecutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListAllExecutions>>
>;
export type GetV1ListAllExecutionsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1ListAllExecutions<
  TData = Awaited<ReturnType<typeof getV1ListAllExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListAllExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListAllExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV1ListAllExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListAllExecutions<
  TData = Awaited<ReturnType<typeof getV1ListAllExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListAllExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListAllExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV1ListAllExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListAllExecutions<
  TData = Awaited<ReturnType<typeof getV1ListAllExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListAllExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all executions
 */

export function useGetV1ListAllExecutions<
  TData = Awaited<ReturnType<typeof getV1ListAllExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListAllExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ListAllExecutionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List all executions
 */
export const prefetchGetV1ListAllExecutionsQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListAllExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListAllExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ListAllExecutionsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV1UserCostSummaryResponse200 = {
  data: UserExecutionCostSummary;
  status: 200;
};

export type getV1UserCostSummaryResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1UserCostSummaryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1UserCostSummaryResponseSuccess =
  getV1UserCostSummaryResponse200 & {
    headers: Headers;
  };
export type getV1UserCostSummaryResponseError = (
  | getV1UserCostSummaryResponse401
  | getV1UserCostSummaryResponse422
) & {
  headers: Headers;
};

export type getV1UserCostSummaryResponse =
  | getV1UserCostSummaryResponseSuccess
  | getV1UserCostSummaryResponseError;

export const getGetV1UserCostSummaryUrl = (
  params?: GetV1UserCostSummaryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/executions/cost-summary?${stringifiedParams}`
    : `/api/executions/cost-summary`;
};

/**
 * Aggregated cost breakdown for the calling user's graph executions.
 * @summary User cost summary
 */
export const getV1UserCostSummary = async (
  params?: GetV1UserCostSummaryParams,
  options?: RequestInit,
): Promise<getV1UserCostSummaryResponse> => {
  return customMutator<getV1UserCostSummaryResponse>(
    getGetV1UserCostSummaryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1UserCostSummaryQueryKey = (
  params?: GetV1UserCostSummaryParams,
) => {
  return [`/api/executions/cost-summary`, ...(params ? [params] : [])] as const;
};

export const getGetV1UserCostSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserCostSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1UserCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserCostSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1UserCostSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1UserCostSummary>>
  > = ({ signal }) =>
    getV1UserCostSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserCostSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1UserCostSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserCostSummary>>
>;
export type GetV1UserCostSummaryQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1UserCostSummary<
  TData = Awaited<ReturnType<typeof getV1UserCostSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV1UserCostSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserCostSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserCostSummary>>,
          TError,
          Awaited<ReturnType<typeof getV1UserCostSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserCostSummary<
  TData = Awaited<ReturnType<typeof getV1UserCostSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1UserCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserCostSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1UserCostSummary>>,
          TError,
          Awaited<ReturnType<typeof getV1UserCostSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1UserCostSummary<
  TData = Awaited<ReturnType<typeof getV1UserCostSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1UserCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserCostSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary User cost summary
 */

export function useGetV1UserCostSummary<
  TData = Awaited<ReturnType<typeof getV1UserCostSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV1UserCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserCostSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1UserCostSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary User cost summary
 */
export const prefetchGetV1UserCostSummaryQuery = async <
  TData = Awaited<ReturnType<typeof getV1UserCostSummary>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV1UserCostSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1UserCostSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1UserCostSummaryQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type deleteV1DeleteGraphExecutionResponse204 = {
  data: void;
  status: 204;
};

export type deleteV1DeleteGraphExecutionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteV1DeleteGraphExecutionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteV1DeleteGraphExecutionResponseSuccess =
  deleteV1DeleteGraphExecutionResponse204 & {
    headers: Headers;
  };
export type deleteV1DeleteGraphExecutionResponseError = (
  | deleteV1DeleteGraphExecutionResponse401
  | deleteV1DeleteGraphExecutionResponse422
) & {
  headers: Headers;
};

export type deleteV1DeleteGraphExecutionResponse =
  | deleteV1DeleteGraphExecutionResponseSuccess
  | deleteV1DeleteGraphExecutionResponseError;

export const getDeleteV1DeleteGraphExecutionUrl = (graphExecId: string) => {
  return `/api/executions/${graphExecId}`;
};

/**
 * @summary Delete graph execution
 */
export const deleteV1DeleteGraphExecution = async (
  graphExecId: string,
  options?: RequestInit,
): Promise<deleteV1DeleteGraphExecutionResponse> => {
  return customMutator<deleteV1DeleteGraphExecutionResponse>(
    getDeleteV1DeleteGraphExecutionUrl(graphExecId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteV1DeleteGraphExecutionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV1DeleteGraphExecution>>,
    TError,
    { graphExecId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV1DeleteGraphExecution>>,
  TError,
  { graphExecId: string },
  TContext
> => {
  const mutationKey = ["deleteV1DeleteGraphExecution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV1DeleteGraphExecution>>,
    { graphExecId: string }
  > = (props) => {
    const { graphExecId } = props ?? {};

    return deleteV1DeleteGraphExecution(graphExecId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV1DeleteGraphExecutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV1DeleteGraphExecution>>
>;

export type DeleteV1DeleteGraphExecutionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Delete graph execution
 */
export const useDeleteV1DeleteGraphExecution = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV1DeleteGraphExecution>>,
      TError,
      { graphExecId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV1DeleteGraphExecution>>,
  TError,
  { graphExecId: string },
  TContext
> => {
  return useMutation(
    getDeleteV1DeleteGraphExecutionMutationOptions(options),
    queryClient,
  );
};
export type getV1ListUserGraphsResponse200 = {
  data: GraphMeta[];
  status: 200;
};

export type getV1ListUserGraphsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1ListUserGraphsResponseSuccess =
  getV1ListUserGraphsResponse200 & {
    headers: Headers;
  };
export type getV1ListUserGraphsResponseError =
  getV1ListUserGraphsResponse401 & {
    headers: Headers;
  };

export type getV1ListUserGraphsResponse =
  | getV1ListUserGraphsResponseSuccess
  | getV1ListUserGraphsResponseError;

export const getGetV1ListUserGraphsUrl = () => {
  return `/api/graphs`;
};

/**
 * @summary List user graphs
 */
export const getV1ListUserGraphs = async (
  options?: RequestInit,
): Promise<getV1ListUserGraphsResponse> => {
  return customMutator<getV1ListUserGraphsResponse>(
    getGetV1ListUserGraphsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1ListUserGraphsQueryKey = () => {
  return [`/api/graphs`] as const;
};

export const getGetV1ListUserGraphsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ListUserGraphs>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1ListUserGraphs>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1ListUserGraphsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListUserGraphs>>
  > = ({ signal }) => getV1ListUserGraphs({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ListUserGraphs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListUserGraphsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListUserGraphs>>
>;
export type GetV1ListUserGraphsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1ListUserGraphs<
  TData = Awaited<ReturnType<typeof getV1ListUserGraphs>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListUserGraphs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListUserGraphs>>,
          TError,
          Awaited<ReturnType<typeof getV1ListUserGraphs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListUserGraphs<
  TData = Awaited<ReturnType<typeof getV1ListUserGraphs>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListUserGraphs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListUserGraphs>>,
          TError,
          Awaited<ReturnType<typeof getV1ListUserGraphs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListUserGraphs<
  TData = Awaited<ReturnType<typeof getV1ListUserGraphs>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListUserGraphs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List user graphs
 */

export function useGetV1ListUserGraphs<
  TData = Awaited<ReturnType<typeof getV1ListUserGraphs>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListUserGraphs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ListUserGraphsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List user graphs
 */
export const prefetchGetV1ListUserGraphsQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListUserGraphs>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListUserGraphs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ListUserGraphsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV1CreateNewGraphResponse200 = {
  data: GraphModel;
  status: 200;
};

export type postV1CreateNewGraphResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1CreateNewGraphResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1CreateNewGraphResponseSuccess =
  postV1CreateNewGraphResponse200 & {
    headers: Headers;
  };
export type postV1CreateNewGraphResponseError = (
  | postV1CreateNewGraphResponse401
  | postV1CreateNewGraphResponse422
) & {
  headers: Headers;
};

export type postV1CreateNewGraphResponse =
  | postV1CreateNewGraphResponseSuccess
  | postV1CreateNewGraphResponseError;

export const getPostV1CreateNewGraphUrl = () => {
  return `/api/graphs`;
};

/**
 * @summary Create new graph
 */
export const postV1CreateNewGraph = async (
  createGraph: CreateGraph,
  options?: RequestInit,
): Promise<postV1CreateNewGraphResponse> => {
  return customMutator<postV1CreateNewGraphResponse>(
    getPostV1CreateNewGraphUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createGraph),
    },
  );
};

export const getPostV1CreateNewGraphMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CreateNewGraph>>,
    TError,
    { data: CreateGraph },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CreateNewGraph>>,
  TError,
  { data: CreateGraph },
  TContext
> => {
  const mutationKey = ["postV1CreateNewGraph"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CreateNewGraph>>,
    { data: CreateGraph }
  > = (props) => {
    const { data } = props ?? {};

    return postV1CreateNewGraph(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CreateNewGraphMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CreateNewGraph>>
>;
export type PostV1CreateNewGraphMutationBody = CreateGraph;
export type PostV1CreateNewGraphMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Create new graph
 */
export const usePostV1CreateNewGraph = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CreateNewGraph>>,
      TError,
      { data: CreateGraph },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CreateNewGraph>>,
  TError,
  { data: CreateGraph },
  TContext
> => {
  return useMutation(
    getPostV1CreateNewGraphMutationOptions(options),
    queryClient,
  );
};
export type deleteV1DeleteGraphPermanentlyResponse200 = {
  data: DeleteGraphResponse;
  status: 200;
};

export type deleteV1DeleteGraphPermanentlyResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteV1DeleteGraphPermanentlyResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteV1DeleteGraphPermanentlyResponseSuccess =
  deleteV1DeleteGraphPermanentlyResponse200 & {
    headers: Headers;
  };
export type deleteV1DeleteGraphPermanentlyResponseError = (
  | deleteV1DeleteGraphPermanentlyResponse401
  | deleteV1DeleteGraphPermanentlyResponse422
) & {
  headers: Headers;
};

export type deleteV1DeleteGraphPermanentlyResponse =
  | deleteV1DeleteGraphPermanentlyResponseSuccess
  | deleteV1DeleteGraphPermanentlyResponseError;

export const getDeleteV1DeleteGraphPermanentlyUrl = (graphId: string) => {
  return `/api/graphs/${graphId}`;
};

/**
 * @summary Delete graph permanently
 */
export const deleteV1DeleteGraphPermanently = async (
  graphId: string,
  options?: RequestInit,
): Promise<deleteV1DeleteGraphPermanentlyResponse> => {
  return customMutator<deleteV1DeleteGraphPermanentlyResponse>(
    getDeleteV1DeleteGraphPermanentlyUrl(graphId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteV1DeleteGraphPermanentlyMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV1DeleteGraphPermanently>>,
    TError,
    { graphId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV1DeleteGraphPermanently>>,
  TError,
  { graphId: string },
  TContext
> => {
  const mutationKey = ["deleteV1DeleteGraphPermanently"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV1DeleteGraphPermanently>>,
    { graphId: string }
  > = (props) => {
    const { graphId } = props ?? {};

    return deleteV1DeleteGraphPermanently(graphId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV1DeleteGraphPermanentlyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV1DeleteGraphPermanently>>
>;

export type DeleteV1DeleteGraphPermanentlyMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Delete graph permanently
 */
export const useDeleteV1DeleteGraphPermanently = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV1DeleteGraphPermanently>>,
      TError,
      { graphId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV1DeleteGraphPermanently>>,
  TError,
  { graphId: string },
  TContext
> => {
  return useMutation(
    getDeleteV1DeleteGraphPermanentlyMutationOptions(options),
    queryClient,
  );
};
export type getV1GetSpecificGraphResponse200 = {
  data: GraphModel;
  status: 200;
};

export type getV1GetSpecificGraphResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetSpecificGraphResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1GetSpecificGraphResponseSuccess =
  getV1GetSpecificGraphResponse200 & {
    headers: Headers;
  };
export type getV1GetSpecificGraphResponseError = (
  | getV1GetSpecificGraphResponse401
  | getV1GetSpecificGraphResponse422
) & {
  headers: Headers;
};

export type getV1GetSpecificGraphResponse =
  | getV1GetSpecificGraphResponseSuccess
  | getV1GetSpecificGraphResponseError;

export const getGetV1GetSpecificGraphUrl = (
  graphId: string,
  params?: GetV1GetSpecificGraphParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/graphs/${graphId}?${stringifiedParams}`
    : `/api/graphs/${graphId}`;
};

/**
 * @summary Get specific graph
 */
export const getV1GetSpecificGraph = async (
  graphId: string,
  params?: GetV1GetSpecificGraphParams,
  options?: RequestInit,
): Promise<getV1GetSpecificGraphResponse> => {
  return customMutator<getV1GetSpecificGraphResponse>(
    getGetV1GetSpecificGraphUrl(graphId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetSpecificGraphQueryKey = (
  graphId: string,
  params?: GetV1GetSpecificGraphParams,
) => {
  return [`/api/graphs/${graphId}`, ...(params ? [params] : [])] as const;
};

export const getGetV1GetSpecificGraphQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1GetSpecificGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1GetSpecificGraphQueryKey(graphId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetSpecificGraph>>
  > = ({ signal }) =>
    getV1GetSpecificGraph(graphId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: graphId !== null && graphId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetSpecificGraphQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetSpecificGraph>>
>;
export type GetV1GetSpecificGraphQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1GetSpecificGraph<
  TData = Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params: undefined | GetV1GetSpecificGraphParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
          TError,
          Awaited<ReturnType<typeof getV1GetSpecificGraph>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetSpecificGraph<
  TData = Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1GetSpecificGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
          TError,
          Awaited<ReturnType<typeof getV1GetSpecificGraph>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetSpecificGraph<
  TData = Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1GetSpecificGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get specific graph
 */

export function useGetV1GetSpecificGraph<
  TData = Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1GetSpecificGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetSpecificGraphQueryOptions(
    graphId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get specific graph
 */
export const prefetchGetV1GetSpecificGraphQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  graphId: string,
  params?: GetV1GetSpecificGraphParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetSpecificGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetSpecificGraphQueryOptions(
    graphId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type putV1UpdateGraphVersionResponse200 = {
  data: UpdateGraphResponse;
  status: 200;
};

export type putV1UpdateGraphVersionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type putV1UpdateGraphVersionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type putV1UpdateGraphVersionResponseSuccess =
  putV1UpdateGraphVersionResponse200 & {
    headers: Headers;
  };
export type putV1UpdateGraphVersionResponseError = (
  | putV1UpdateGraphVersionResponse401
  | putV1UpdateGraphVersionResponse422
) & {
  headers: Headers;
};

export type putV1UpdateGraphVersionResponse =
  | putV1UpdateGraphVersionResponseSuccess
  | putV1UpdateGraphVersionResponseError;

export const getPutV1UpdateGraphVersionUrl = (graphId: string) => {
  return `/api/graphs/${graphId}`;
};

/**
 * @summary Update graph version
 */
export const putV1UpdateGraphVersion = async (
  graphId: string,
  graph: Graph,
  options?: RequestInit,
): Promise<putV1UpdateGraphVersionResponse> => {
  return customMutator<putV1UpdateGraphVersionResponse>(
    getPutV1UpdateGraphVersionUrl(graphId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(graph),
    },
  );
};

export const getPutV1UpdateGraphVersionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putV1UpdateGraphVersion>>,
    TError,
    { graphId: string; data: Graph },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putV1UpdateGraphVersion>>,
  TError,
  { graphId: string; data: Graph },
  TContext
> => {
  const mutationKey = ["putV1UpdateGraphVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putV1UpdateGraphVersion>>,
    { graphId: string; data: Graph }
  > = (props) => {
    const { graphId, data } = props ?? {};

    return putV1UpdateGraphVersion(graphId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutV1UpdateGraphVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof putV1UpdateGraphVersion>>
>;
export type PutV1UpdateGraphVersionMutationBody = Graph;
export type PutV1UpdateGraphVersionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Update graph version
 */
export const usePutV1UpdateGraphVersion = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putV1UpdateGraphVersion>>,
      TError,
      { graphId: string; data: Graph },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putV1UpdateGraphVersion>>,
  TError,
  { graphId: string; data: Graph },
  TContext
> => {
  return useMutation(
    getPutV1UpdateGraphVersionMutationOptions(options),
    queryClient,
  );
};
export type postV1ExecuteGraphAgentResponse200 = {
  data: GraphExecutionMeta;
  status: 200;
};

export type postV1ExecuteGraphAgentResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1ExecuteGraphAgentResponse402 = {
  data: void;
  status: 402;
};

export type postV1ExecuteGraphAgentResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1ExecuteGraphAgentResponse503 = {
  data: void;
  status: 503;
};

export type postV1ExecuteGraphAgentResponseSuccess =
  postV1ExecuteGraphAgentResponse200 & {
    headers: Headers;
  };
export type postV1ExecuteGraphAgentResponseError = (
  | postV1ExecuteGraphAgentResponse401
  | postV1ExecuteGraphAgentResponse402
  | postV1ExecuteGraphAgentResponse422
  | postV1ExecuteGraphAgentResponse503
) & {
  headers: Headers;
};

export type postV1ExecuteGraphAgentResponse =
  | postV1ExecuteGraphAgentResponseSuccess
  | postV1ExecuteGraphAgentResponseError;

export const getPostV1ExecuteGraphAgentUrl = (
  graphId: string,
  graphVersion: number | null,
  params?: PostV1ExecuteGraphAgentParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/graphs/${graphId}/execute/${graphVersion}?${stringifiedParams}`
    : `/api/graphs/${graphId}/execute/${graphVersion}`;
};

/**
 * @summary Execute graph agent
 */
export const postV1ExecuteGraphAgent = async (
  graphId: string,
  graphVersion: number | null,
  bodyPostV1ExecuteGraphAgent?: BodyPostV1ExecuteGraphAgent,
  params?: PostV1ExecuteGraphAgentParams,
  options?: RequestInit,
): Promise<postV1ExecuteGraphAgentResponse> => {
  return customMutator<postV1ExecuteGraphAgentResponse>(
    getPostV1ExecuteGraphAgentUrl(graphId, graphVersion, params),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bodyPostV1ExecuteGraphAgent),
    },
  );
};

export const getPostV1ExecuteGraphAgentMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1ExecuteGraphAgent>>,
    TError,
    {
      graphId: string;
      graphVersion: number | null;
      data?: BodyPostV1ExecuteGraphAgent;
      params?: PostV1ExecuteGraphAgentParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1ExecuteGraphAgent>>,
  TError,
  {
    graphId: string;
    graphVersion: number | null;
    data?: BodyPostV1ExecuteGraphAgent;
    params?: PostV1ExecuteGraphAgentParams;
  },
  TContext
> => {
  const mutationKey = ["postV1ExecuteGraphAgent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1ExecuteGraphAgent>>,
    {
      graphId: string;
      graphVersion: number | null;
      data?: BodyPostV1ExecuteGraphAgent;
      params?: PostV1ExecuteGraphAgentParams;
    }
  > = (props) => {
    const { graphId, graphVersion, data, params } = props ?? {};

    return postV1ExecuteGraphAgent(
      graphId,
      graphVersion,
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1ExecuteGraphAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1ExecuteGraphAgent>>
>;
export type PostV1ExecuteGraphAgentMutationBody =
  | BodyPostV1ExecuteGraphAgent
  | undefined;
export type PostV1ExecuteGraphAgentMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Execute graph agent
 */
export const usePostV1ExecuteGraphAgent = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1ExecuteGraphAgent>>,
      TError,
      {
        graphId: string;
        graphVersion: number | null;
        data?: BodyPostV1ExecuteGraphAgent;
        params?: PostV1ExecuteGraphAgentParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1ExecuteGraphAgent>>,
  TError,
  {
    graphId: string;
    graphVersion: number | null;
    data?: BodyPostV1ExecuteGraphAgent;
    params?: PostV1ExecuteGraphAgentParams;
  },
  TContext
> => {
  return useMutation(
    getPostV1ExecuteGraphAgentMutationOptions(options),
    queryClient,
  );
};
export type getV1ListGraphExecutionsResponse200 = {
  data: GraphExecutionsPaginated;
  status: 200;
};

export type getV1ListGraphExecutionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1ListGraphExecutionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1ListGraphExecutionsResponseSuccess =
  getV1ListGraphExecutionsResponse200 & {
    headers: Headers;
  };
export type getV1ListGraphExecutionsResponseError = (
  | getV1ListGraphExecutionsResponse401
  | getV1ListGraphExecutionsResponse422
) & {
  headers: Headers;
};

export type getV1ListGraphExecutionsResponse =
  | getV1ListGraphExecutionsResponseSuccess
  | getV1ListGraphExecutionsResponseError;

export const getGetV1ListGraphExecutionsUrl = (
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/graphs/${graphId}/executions?${stringifiedParams}`
    : `/api/graphs/${graphId}/executions`;
};

/**
 * @summary List graph executions
 */
export const getV1ListGraphExecutions = async (
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: RequestInit,
): Promise<getV1ListGraphExecutionsResponse> => {
  return customMutator<getV1ListGraphExecutionsResponse>(
    getGetV1ListGraphExecutionsUrl(graphId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1ListGraphExecutionsInfiniteQueryKey = (
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
) => {
  return [
    `/api/graphs/${graphId}/executions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV1ListGraphExecutionsQueryKey = (
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
) => {
  return [
    `/api/graphs/${graphId}/executions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV1ListGraphExecutionsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
    GetV1ListGraphExecutionsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData,
        QueryKey,
        GetV1ListGraphExecutionsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV1ListGraphExecutionsInfiniteQueryKey(graphId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
    QueryKey,
    GetV1ListGraphExecutionsParams["page"]
  > = ({ signal, pageParam }) =>
    getV1ListGraphExecutions(
      graphId,
      { ...params, page: pageParam ?? params?.["page"] },
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: graphId !== null && graphId !== undefined,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
    TError,
    TData,
    QueryKey,
    GetV1ListGraphExecutionsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListGraphExecutionsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListGraphExecutions>>
>;
export type GetV1ListGraphExecutionsInfiniteQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1ListGraphExecutionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
    GetV1ListGraphExecutionsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params: undefined | GetV1ListGraphExecutionsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData,
        QueryKey,
        GetV1ListGraphExecutionsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListGraphExecutionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
    GetV1ListGraphExecutionsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData,
        QueryKey,
        GetV1ListGraphExecutionsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListGraphExecutionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
    GetV1ListGraphExecutionsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData,
        QueryKey,
        GetV1ListGraphExecutionsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List graph executions
 */

export function useGetV1ListGraphExecutionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
    GetV1ListGraphExecutionsParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData,
        QueryKey,
        GetV1ListGraphExecutionsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ListGraphExecutionsInfiniteQueryOptions(
    graphId,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List graph executions
 */
export const prefetchGetV1ListGraphExecutionsInfiniteQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData,
        QueryKey,
        GetV1ListGraphExecutionsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ListGraphExecutionsInfiniteQueryOptions(
    graphId,
    params,
    options,
  );

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getGetV1ListGraphExecutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV1ListGraphExecutionsQueryKey(graphId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListGraphExecutions>>
  > = ({ signal }) =>
    getV1ListGraphExecutions(graphId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: graphId !== null && graphId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListGraphExecutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListGraphExecutions>>
>;
export type GetV1ListGraphExecutionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1ListGraphExecutions<
  TData = Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params: undefined | GetV1ListGraphExecutionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV1ListGraphExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListGraphExecutions<
  TData = Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
          TError,
          Awaited<ReturnType<typeof getV1ListGraphExecutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListGraphExecutions<
  TData = Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List graph executions
 */

export function useGetV1ListGraphExecutions<
  TData = Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ListGraphExecutionsQueryOptions(
    graphId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List graph executions
 */
export const prefetchGetV1ListGraphExecutionsQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  graphId: string,
  params?: GetV1ListGraphExecutionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListGraphExecutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ListGraphExecutionsQueryOptions(
    graphId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV1GetExecutionDetailsResponse200 = {
  data: GraphExecution | GraphExecutionWithNodes;
  status: 200;
};

export type getV1GetExecutionDetailsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetExecutionDetailsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1GetExecutionDetailsResponseSuccess =
  getV1GetExecutionDetailsResponse200 & {
    headers: Headers;
  };
export type getV1GetExecutionDetailsResponseError = (
  | getV1GetExecutionDetailsResponse401
  | getV1GetExecutionDetailsResponse422
) & {
  headers: Headers;
};

export type getV1GetExecutionDetailsResponse =
  | getV1GetExecutionDetailsResponseSuccess
  | getV1GetExecutionDetailsResponseError;

export const getGetV1GetExecutionDetailsUrl = (
  graphId: string,
  graphExecId: string,
) => {
  return `/api/graphs/${graphId}/executions/${graphExecId}`;
};

/**
 * @summary Get execution details
 */
export const getV1GetExecutionDetails = async (
  graphId: string,
  graphExecId: string,
  options?: RequestInit,
): Promise<getV1GetExecutionDetailsResponse> => {
  return customMutator<getV1GetExecutionDetailsResponse>(
    getGetV1GetExecutionDetailsUrl(graphId, graphExecId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetExecutionDetailsQueryKey = (
  graphId: string,
  graphExecId: string,
) => {
  return [`/api/graphs/${graphId}/executions/${graphExecId}`] as const;
};

export const getGetV1GetExecutionDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  graphExecId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV1GetExecutionDetailsQueryKey(graphId, graphExecId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetExecutionDetails>>
  > = ({ signal }) =>
    getV1GetExecutionDetails(graphId, graphExecId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      graphId !== null &&
      graphId !== undefined &&
      graphExecId !== null &&
      graphExecId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetExecutionDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetExecutionDetails>>
>;
export type GetV1GetExecutionDetailsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1GetExecutionDetails<
  TData = Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  graphExecId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
          TError,
          Awaited<ReturnType<typeof getV1GetExecutionDetails>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetExecutionDetails<
  TData = Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  graphExecId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
          TError,
          Awaited<ReturnType<typeof getV1GetExecutionDetails>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetExecutionDetails<
  TData = Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  graphExecId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get execution details
 */

export function useGetV1GetExecutionDetails<
  TData = Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  graphExecId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetExecutionDetailsQueryOptions(
    graphId,
    graphExecId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get execution details
 */
export const prefetchGetV1GetExecutionDetailsQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  graphId: string,
  graphExecId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetExecutionDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetExecutionDetailsQueryOptions(
    graphId,
    graphExecId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV1StopGraphExecutionResponse200 = {
  data: GraphExecutionMeta | null;
  status: 200;
};

export type postV1StopGraphExecutionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1StopGraphExecutionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1StopGraphExecutionResponseSuccess =
  postV1StopGraphExecutionResponse200 & {
    headers: Headers;
  };
export type postV1StopGraphExecutionResponseError = (
  | postV1StopGraphExecutionResponse401
  | postV1StopGraphExecutionResponse422
) & {
  headers: Headers;
};

export type postV1StopGraphExecutionResponse =
  | postV1StopGraphExecutionResponseSuccess
  | postV1StopGraphExecutionResponseError;

export const getPostV1StopGraphExecutionUrl = (
  graphId: string,
  graphExecId: string,
) => {
  return `/api/graphs/${graphId}/executions/${graphExecId}/stop`;
};

/**
 * @summary Stop graph execution
 */
export const postV1StopGraphExecution = async (
  graphId: string,
  graphExecId: string,
  options?: RequestInit,
): Promise<postV1StopGraphExecutionResponse> => {
  return customMutator<postV1StopGraphExecutionResponse>(
    getPostV1StopGraphExecutionUrl(graphId, graphExecId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV1StopGraphExecutionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1StopGraphExecution>>,
    TError,
    { graphId: string; graphExecId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1StopGraphExecution>>,
  TError,
  { graphId: string; graphExecId: string },
  TContext
> => {
  const mutationKey = ["postV1StopGraphExecution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1StopGraphExecution>>,
    { graphId: string; graphExecId: string }
  > = (props) => {
    const { graphId, graphExecId } = props ?? {};

    return postV1StopGraphExecution(graphId, graphExecId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1StopGraphExecutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1StopGraphExecution>>
>;

export type PostV1StopGraphExecutionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Stop graph execution
 */
export const usePostV1StopGraphExecution = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1StopGraphExecution>>,
      TError,
      { graphId: string; graphExecId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1StopGraphExecution>>,
  TError,
  { graphId: string; graphExecId: string },
  TContext
> => {
  return useMutation(
    getPostV1StopGraphExecutionMutationOptions(options),
    queryClient,
  );
};
export type patchV1UpdateGraphSettingsResponse200 = {
  data: GraphSettings;
  status: 200;
};

export type patchV1UpdateGraphSettingsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type patchV1UpdateGraphSettingsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type patchV1UpdateGraphSettingsResponseSuccess =
  patchV1UpdateGraphSettingsResponse200 & {
    headers: Headers;
  };
export type patchV1UpdateGraphSettingsResponseError = (
  | patchV1UpdateGraphSettingsResponse401
  | patchV1UpdateGraphSettingsResponse422
) & {
  headers: Headers;
};

export type patchV1UpdateGraphSettingsResponse =
  | patchV1UpdateGraphSettingsResponseSuccess
  | patchV1UpdateGraphSettingsResponseError;

export const getPatchV1UpdateGraphSettingsUrl = (graphId: string) => {
  return `/api/graphs/${graphId}/settings`;
};

/**
 * Update graph settings for the user's library agent.
 * @summary Update graph settings
 */
export const patchV1UpdateGraphSettings = async (
  graphId: string,
  graphSettings: GraphSettings,
  options?: RequestInit,
): Promise<patchV1UpdateGraphSettingsResponse> => {
  return customMutator<patchV1UpdateGraphSettingsResponse>(
    getPatchV1UpdateGraphSettingsUrl(graphId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(graphSettings),
    },
  );
};

export const getPatchV1UpdateGraphSettingsMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1UpdateGraphSettings>>,
    TError,
    { graphId: string; data: GraphSettings },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV1UpdateGraphSettings>>,
  TError,
  { graphId: string; data: GraphSettings },
  TContext
> => {
  const mutationKey = ["patchV1UpdateGraphSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV1UpdateGraphSettings>>,
    { graphId: string; data: GraphSettings }
  > = (props) => {
    const { graphId, data } = props ?? {};

    return patchV1UpdateGraphSettings(graphId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV1UpdateGraphSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV1UpdateGraphSettings>>
>;
export type PatchV1UpdateGraphSettingsMutationBody = GraphSettings;
export type PatchV1UpdateGraphSettingsMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Update graph settings
 */
export const usePatchV1UpdateGraphSettings = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV1UpdateGraphSettings>>,
      TError,
      { graphId: string; data: GraphSettings },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV1UpdateGraphSettings>>,
  TError,
  { graphId: string; data: GraphSettings },
  TContext
> => {
  return useMutation(
    getPatchV1UpdateGraphSettingsMutationOptions(options),
    queryClient,
  );
};
export type getV1GetAllGraphVersionsResponse200 = {
  data: GraphModel[];
  status: 200;
};

export type getV1GetAllGraphVersionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetAllGraphVersionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1GetAllGraphVersionsResponseSuccess =
  getV1GetAllGraphVersionsResponse200 & {
    headers: Headers;
  };
export type getV1GetAllGraphVersionsResponseError = (
  | getV1GetAllGraphVersionsResponse401
  | getV1GetAllGraphVersionsResponse422
) & {
  headers: Headers;
};

export type getV1GetAllGraphVersionsResponse =
  | getV1GetAllGraphVersionsResponseSuccess
  | getV1GetAllGraphVersionsResponseError;

export const getGetV1GetAllGraphVersionsUrl = (graphId: string) => {
  return `/api/graphs/${graphId}/versions`;
};

/**
 * @summary Get all graph versions
 */
export const getV1GetAllGraphVersions = async (
  graphId: string,
  options?: RequestInit,
): Promise<getV1GetAllGraphVersionsResponse> => {
  return customMutator<getV1GetAllGraphVersionsResponse>(
    getGetV1GetAllGraphVersionsUrl(graphId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetAllGraphVersionsQueryKey = (graphId: string) => {
  return [`/api/graphs/${graphId}/versions`] as const;
};

export const getGetV1GetAllGraphVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1GetAllGraphVersionsQueryKey(graphId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetAllGraphVersions>>
  > = ({ signal }) =>
    getV1GetAllGraphVersions(graphId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: graphId !== null && graphId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetAllGraphVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetAllGraphVersions>>
>;
export type GetV1GetAllGraphVersionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1GetAllGraphVersions<
  TData = Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
          TError,
          Awaited<ReturnType<typeof getV1GetAllGraphVersions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetAllGraphVersions<
  TData = Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
          TError,
          Awaited<ReturnType<typeof getV1GetAllGraphVersions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetAllGraphVersions<
  TData = Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all graph versions
 */

export function useGetV1GetAllGraphVersions<
  TData = Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetAllGraphVersionsQueryOptions(
    graphId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get all graph versions
 */
export const prefetchGetV1GetAllGraphVersionsQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  graphId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetAllGraphVersions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetAllGraphVersionsQueryOptions(
    graphId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type putV1SetActiveGraphVersionResponse200 = {
  data: SetActiveGraphVersionResponse;
  status: 200;
};

export type putV1SetActiveGraphVersionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type putV1SetActiveGraphVersionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type putV1SetActiveGraphVersionResponseSuccess =
  putV1SetActiveGraphVersionResponse200 & {
    headers: Headers;
  };
export type putV1SetActiveGraphVersionResponseError = (
  | putV1SetActiveGraphVersionResponse401
  | putV1SetActiveGraphVersionResponse422
) & {
  headers: Headers;
};

export type putV1SetActiveGraphVersionResponse =
  | putV1SetActiveGraphVersionResponseSuccess
  | putV1SetActiveGraphVersionResponseError;

export const getPutV1SetActiveGraphVersionUrl = (graphId: string) => {
  return `/api/graphs/${graphId}/versions/active`;
};

/**
 * @summary Set active graph version
 */
export const putV1SetActiveGraphVersion = async (
  graphId: string,
  setGraphActiveVersion: SetGraphActiveVersion,
  options?: RequestInit,
): Promise<putV1SetActiveGraphVersionResponse> => {
  return customMutator<putV1SetActiveGraphVersionResponse>(
    getPutV1SetActiveGraphVersionUrl(graphId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setGraphActiveVersion),
    },
  );
};

export const getPutV1SetActiveGraphVersionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putV1SetActiveGraphVersion>>,
    TError,
    { graphId: string; data: SetGraphActiveVersion },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putV1SetActiveGraphVersion>>,
  TError,
  { graphId: string; data: SetGraphActiveVersion },
  TContext
> => {
  const mutationKey = ["putV1SetActiveGraphVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putV1SetActiveGraphVersion>>,
    { graphId: string; data: SetGraphActiveVersion }
  > = (props) => {
    const { graphId, data } = props ?? {};

    return putV1SetActiveGraphVersion(graphId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutV1SetActiveGraphVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof putV1SetActiveGraphVersion>>
>;
export type PutV1SetActiveGraphVersionMutationBody = SetGraphActiveVersion;
export type PutV1SetActiveGraphVersionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Set active graph version
 */
export const usePutV1SetActiveGraphVersion = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putV1SetActiveGraphVersion>>,
      TError,
      { graphId: string; data: SetGraphActiveVersion },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putV1SetActiveGraphVersion>>,
  TError,
  { graphId: string; data: SetGraphActiveVersion },
  TContext
> => {
  return useMutation(
    getPutV1SetActiveGraphVersionMutationOptions(options),
    queryClient,
  );
};
export type getV1GetGraphVersionResponse200 = {
  data: GraphModel;
  status: 200;
};

export type getV1GetGraphVersionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetGraphVersionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1GetGraphVersionResponseSuccess =
  getV1GetGraphVersionResponse200 & {
    headers: Headers;
  };
export type getV1GetGraphVersionResponseError = (
  | getV1GetGraphVersionResponse401
  | getV1GetGraphVersionResponse422
) & {
  headers: Headers;
};

export type getV1GetGraphVersionResponse =
  | getV1GetGraphVersionResponseSuccess
  | getV1GetGraphVersionResponseError;

export const getGetV1GetGraphVersionUrl = (
  graphId: string,
  version: number | null,
  params?: GetV1GetGraphVersionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/graphs/${graphId}/versions/${version}?${stringifiedParams}`
    : `/api/graphs/${graphId}/versions/${version}`;
};

/**
 * @summary Get graph version
 */
export const getV1GetGraphVersion = async (
  graphId: string,
  version: number | null,
  params?: GetV1GetGraphVersionParams,
  options?: RequestInit,
): Promise<getV1GetGraphVersionResponse> => {
  return customMutator<getV1GetGraphVersionResponse>(
    getGetV1GetGraphVersionUrl(graphId, version, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetGraphVersionQueryKey = (
  graphId: string,
  version: number | null,
  params?: GetV1GetGraphVersionParams,
) => {
  return [
    `/api/graphs/${graphId}/versions/${version}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV1GetGraphVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetGraphVersion>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  version: number | null,
  params?: GetV1GetGraphVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetGraphVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV1GetGraphVersionQueryKey(graphId, version, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetGraphVersion>>
  > = ({ signal }) =>
    getV1GetGraphVersion(graphId, version, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      graphId !== null &&
      graphId !== undefined &&
      version !== null &&
      version !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetGraphVersion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetGraphVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetGraphVersion>>
>;
export type GetV1GetGraphVersionQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1GetGraphVersion<
  TData = Awaited<ReturnType<typeof getV1GetGraphVersion>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  version: number | null,
  params: undefined | GetV1GetGraphVersionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetGraphVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetGraphVersion>>,
          TError,
          Awaited<ReturnType<typeof getV1GetGraphVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetGraphVersion<
  TData = Awaited<ReturnType<typeof getV1GetGraphVersion>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  version: number | null,
  params?: GetV1GetGraphVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetGraphVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetGraphVersion>>,
          TError,
          Awaited<ReturnType<typeof getV1GetGraphVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetGraphVersion<
  TData = Awaited<ReturnType<typeof getV1GetGraphVersion>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  version: number | null,
  params?: GetV1GetGraphVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetGraphVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get graph version
 */

export function useGetV1GetGraphVersion<
  TData = Awaited<ReturnType<typeof getV1GetGraphVersion>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  version: number | null,
  params?: GetV1GetGraphVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetGraphVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetGraphVersionQueryOptions(
    graphId,
    version,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get graph version
 */
export const prefetchGetV1GetGraphVersionQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetGraphVersion>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  graphId: string,
  version: number | null,
  params?: GetV1GetGraphVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetGraphVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetGraphVersionQueryOptions(
    graphId,
    version,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type downloadSharedFileResponse200 = {
  data: unknown;
  status: 200;
};

export type downloadSharedFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type downloadSharedFileResponseSuccess =
  downloadSharedFileResponse200 & {
    headers: Headers;
  };
export type downloadSharedFileResponseError = downloadSharedFileResponse422 & {
  headers: Headers;
};

export type downloadSharedFileResponse =
  | downloadSharedFileResponseSuccess
  | downloadSharedFileResponseError;

export const getDownloadSharedFileUrl = (
  shareToken: string,
  fileId: string,
) => {
  return `/api/public/shared/${shareToken}/files/${fileId}/download`;
};

/**
 * Download a workspace file from a shared execution (no auth required).
 *
 * Validates that the file was explicitly exposed when sharing was enabled.
 * Returns a uniform 404 for all failure modes to prevent enumeration attacks.
 * @summary Download a file from a shared execution
 */
export const downloadSharedFile = async (
  shareToken: string,
  fileId: string,
  options?: RequestInit,
): Promise<downloadSharedFileResponse> => {
  return customMutator<downloadSharedFileResponse>(
    getDownloadSharedFileUrl(shareToken, fileId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getDownloadSharedFileQueryKey = (
  shareToken: string,
  fileId: string,
) => {
  return [`/api/public/shared/${shareToken}/files/${fileId}/download`] as const;
};

export const getDownloadSharedFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadSharedFile>>,
  TError = HTTPValidationError,
>(
  shareToken: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadSharedFileQueryKey(shareToken, fileId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadSharedFile>>
  > = ({ signal }) =>
    downloadSharedFile(shareToken, fileId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      shareToken !== null &&
      shareToken !== undefined &&
      fileId !== null &&
      fileId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadSharedFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadSharedFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadSharedFile>>
>;
export type DownloadSharedFileQueryError = HTTPValidationError;

export function useDownloadSharedFile<
  TData = Awaited<ReturnType<typeof downloadSharedFile>>,
  TError = HTTPValidationError,
>(
  shareToken: string,
  fileId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedFile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSharedFile>>,
          TError,
          Awaited<ReturnType<typeof downloadSharedFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadSharedFile<
  TData = Awaited<ReturnType<typeof downloadSharedFile>>,
  TError = HTTPValidationError,
>(
  shareToken: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedFile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSharedFile>>,
          TError,
          Awaited<ReturnType<typeof downloadSharedFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadSharedFile<
  TData = Awaited<ReturnType<typeof downloadSharedFile>>,
  TError = HTTPValidationError,
>(
  shareToken: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download a file from a shared execution
 */

export function useDownloadSharedFile<
  TData = Awaited<ReturnType<typeof downloadSharedFile>>,
  TError = HTTPValidationError,
>(
  shareToken: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadSharedFileQueryOptions(
    shareToken,
    fileId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download a file from a shared execution
 */
export const prefetchDownloadSharedFileQuery = async <
  TData = Awaited<ReturnType<typeof downloadSharedFile>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  shareToken: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadSharedFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getDownloadSharedFileQueryOptions(
    shareToken,
    fileId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
